import { Path } from "enums";
import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { NoPage } from "../components/commons";
const PricelocqBusinessPage = () => {
  return (
    <Switch>
      <Route exact path={Path.PricelocqBusiness} component={NoPage} />
      <Redirect to={Path.PricelocqBusiness} />
    </Switch>
  );
};

export default PricelocqBusinessPage;
